import { Plus, Trash2 } from "lucide-react";
import { INPUT } from "./ui";

// Editor for a list of { label, description } segments (audiences or themes).
export default function SegmentEditor({ items, onChange, labelPlaceholder, descPlaceholder, addLabel }) {
  const list = items || [];
  const set = (i, patch) => onChange(list.map((x, j) => (j === i ? { ...x, ...patch } : x)));
  const remove = (i) => onChange(list.filter((_, j) => j !== i));
  const add = () => onChange([...list, { label: "", description: "" }]);

  return (
    <div className="space-y-3">
      {list.map((it, i) => (
        <div key={i} className="rounded-2xl border border-border bg-surface p-3.5">
          <div className="flex items-start gap-2">
            <div className="flex-1 min-w-0 space-y-2">
              <input
                className={`${INPUT} font-medium`}
                value={it.label || ""}
                placeholder={labelPlaceholder}
                onChange={(e) => set(i, { label: e.target.value })}
              />
              <textarea
                className={`${INPUT} min-h-[62px] leading-relaxed`}
                value={it.description || ""}
                placeholder={descPlaceholder}
                onChange={(e) => set(i, { description: e.target.value })}
              />
            </div>
            <button
              onClick={() => remove(i)}
              title="Remove"
              className="mt-1 w-8 h-8 rounded-lg flex items-center justify-center text-muted hover:bg-foreground/5 hover:text-foreground transition shrink-0"
            >
              <Trash2 size={15} />
            </button>
          </div>
        </div>
      ))}
      {list.length === 0 ? <div className="text-[13.5px] text-faint">Nothing yet.</div> : null}
      <button onClick={add} className="text-[13.5px] text-muted hover:text-foreground transition flex items-center gap-1.5">
        <Plus size={15} /> {addLabel}
      </button>
    </div>
  );
}